var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoneContent"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.specialZoneName))]),_c('div',{staticClass:"info"},[_vm._t("imgLayout")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }